<soft-field-ok
  fieldOkName="ktostamm.lieferant"
  placeholder="Lieferantenname oder Lieferantennummer"
  [title]="configuration()?.title ?? ''"
  [subtitle]="configuration()?.subtitle ?? ''"
  [parameters]="parameters()"
  [readonly]="readonly()"
  [value]="value()"
  (valueChange)="valueChange.emit($event)"
>
</soft-field-ok>
